import axios from "../axios-auth";
import orginal_axios from "axios";

export const stockTransferService = {
  getStockTransferList,
  getAllStockTransferList,
  saveStockTransfer,
  getStockTransferDetail,
  printStockTransferInvoice,
  saveStockTransferExcel,
  exportStockTransferExcel,
  getStockTransferByRequestNo,
  exportAllStockTransferExcel,
  getStockTransferExcelTemplate
};

function getAllStockTransferList(searchParams) {
  let params = {
    sort: "issueDate,asc"
  };
  if (searchParams.fromWarehouseId) {
    params["fromWarehouseId"] = searchParams.fromWarehouseId;
  }
  if (searchParams.toWarehouseId) {
    params["toWarehouseId"] = searchParams.toWarehouseId;
  }
  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.serialNo) {
    params["serialNo"] = searchParams.serialNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.type) {
    params["type"] = searchParams.type;
  }
  if (searchParams.transferType) {
    params["transferType"] = searchParams.transferType;
  }
  if (searchParams.updateUserId) {
    params["updateUserId"] = searchParams.updateUserId;
  }
  if (searchParams.fromBinIds) {
    params["fromBinIds"] = searchParams.fromBinIds.join();
  }
  if (searchParams.toBinIds) {
    params["toBinIds"] = searchParams.toBinIds.join();
  }
  return axios.get("/auth/stock-transfers", { params });
}
function getStockTransferList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.fromWarehouseId) {
    params["fromWarehouseId"] = searchParams.fromWarehouseId;
  }
  if (searchParams.toWarehouseId) {
    params["toWarehouseId"] = searchParams.toWarehouseId;
  }
  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.serialNo) {
    params["serialNo"] = searchParams.serialNo;
  }
  if (searchParams.requestNo) {
    params["requestNo"] = searchParams.requestNo;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.transferType) {
    params["transferType"] = searchParams.transferType;
  }
  if (searchParams.updateUserId) {
    params["updateUserId"] = searchParams.updateUserId;
  }
  if (searchParams.fromBinIds) {
    params["fromBinIds"] = searchParams.fromBinIds.join();
  }
  if (searchParams.toBinIds) {
    params["toBinIds"] = searchParams.toBinIds.join();
  }
  return axios.get("/auth/stock-transfers", { params });
}

function saveStockTransfer(stockTransfer) {
  if (!stockTransfer.id) {
    // new stockTransfer
    return axios.post("/auth/stock-transfer", stockTransfer);
  } else {
    // edit
    return axios.put("/auth/stock-transfer", stockTransfer);
  }
}

function getStockTransferDetail(id) {
  return axios.get("/auth/stock-transfer/" + id);
}

function getStockTransferByRequestNo(requestNo) {
  return axios.get("/auth/stock-transfer-request-no/" + requestNo)
}

function printStockTransferInvoice(id) {
  return orginal_axios({
    url: axios.defaults.baseURL + "/auth/print-stock-transfer-invoice/" + id,
    method: "GET",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/pdf",
      "Content-Type": "application/json"
    }
  }).then(function (response) {
    return new Blob([response.data], { type: "application/pdf" });
  });
}

function saveStockTransferExcel(file) {
  return axios.post('/auth/stock-transfer-excel',
    file,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

function exportStockTransferExcel(id) {
  return orginal_axios({
    url: axios.defaults.baseURL + "/auth/stock-transfer-excel/" + id,
    method: "GET",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function exportAllStockTransferExcel(searchParams) {
  let params = {};

  if (searchParams.fromWarehouseId) {
    params["fromWarehouseId"] = searchParams.fromWarehouseId
  }

  if (searchParams.toWarehouseId) {
    params["toWarehouseId"] = searchParams.toWarehouseId;
  }

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }

  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }

  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }

  if (searchParams.serialNo) {
    params["serialNo"] = searchParams.serialNo;
  }

  if (searchParams.status) {
    params["status"] = searchParams.status;
  }

  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }

  if (searchParams.type) {
    params["type"] = searchParams.type;
  }

  if (searchParams.transferType) {
    params["transferType"] = searchParams.transferType;
  }

  if (searchParams.updateUserId) {
    params["updateUserId"] = searchParams.updateUserId;
  }

  if (searchParams.fromBinIds) {
    params["fromBinIds"] = searchParams.fromBinIds.join();
  }

  if (searchParams.toBinIds) {
    params["toBinIds"] = searchParams.toBinIds.join();
  }

  return orginal_axios({
    url: axios.defaults.baseURL + "/auth/stock-transfer-header-detail-excel/",
    method: "GET",
    responseType: "arraybuffer", // important
    params,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function getStockTransferExcelTemplate() {
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/stock-transfer-excel-template",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}